import Button from '@/components/Button'
import EmptyBlock from '@/components/EmptyBlock'
import Layout, { Stack } from '@/components/Layout'
import LottieImage from '@/components/LottieImage'
import Text from '@/components/Text'
import { toLoginAuthUrl } from '@/lib/authUrl'
import { useRouter } from 'next/router'
import React, { useEffect, useState } from 'react'
import * as styles from './styles'

interface Props {
  title: string
  caption: string
  ctaText: string
}

const LoginSignUpPrompt: React.FC<Props> = ({ caption, ctaText, title }) => {
  const router = useRouter()
  const [authUrl, setAuthUrl] = useState('')

  useEffect(() => {
    setAuthUrl(toLoginAuthUrl(router.asPath))
  }, [router.asPath])

  return (
    <div className={styles.root}>
      <EmptyBlock>
        <Layout>
          <Stack y alignItems="center" justifyContent="space-between">
            <div className={`${styles.iconAnimationContainer} mb-sm`}>
              <LottieImage
                autoplay
                loop
                className={styles.iconAnimation}
                name="lock-close-animation"
                path={'https://ddq2bomue87t4.cloudfront.net/dialog-icons/lock-generic.json'}
              />
            </div>
            <Text weight="lg" className="mb-xxxs" size="md" tag="h4" responsiveSize={{ sm: 'md', md: 'lg' }}>
              {title}
            </Text>
            <Text tag="p" size="xs" weight="sm">
              {caption}
            </Text>
            <Button
              label={
                <Text responsiveSize={{ lg: 'xs' }} size="xxs">
                  {ctaText}
                </Text>
              }
              theme="secondary"
              component="a"
              href={authUrl}
              className="mt-md"
            />
          </Stack>
        </Layout>
      </EmptyBlock>
    </div>
  )
}
export default LoginSignUpPrompt
